// 法務ページ（特商法表記 / 利用規約 / プライバシーポリシー）で共有する事業者情報。
// 3ページとフッターで同じ値を書き写すと改定時に片方だけ古くなるため、ここを正本にする。

export const SUPPORT_EMAIL = 'support@chilili.co.jp';

// 特商法表記に必要な法人情報（#38 で 2026-08-14 に確定）。
export const COMPANY = {
  name: '株式会社chilili.com',
  address: '東京都港区北青山1-3-3 三橋ビル3階',
  representative: '松本 雄己',
  serviceName: 'ちりり競馬',
};

// 料金は backend の modules/billing/pricing.py の PRICE_JPY_TAX_INCLUDED と一致させる。
// 契約コンテンツ数（中央 / 地方 / 競輪）で決まる月額（税込）。
export const MONTHLY_PRICES_TAX_INCLUDED = [
  { contents: 1, price: 3000 },
  { contents: 2, price: 5000 },
  { contents: 3, price: 7500 },
];

const formatYen = (price) => `${price.toLocaleString('ja-JP')}円`;

// 特商法表記の「販売価格」欄と利用規約 第4条の文面は、必ず上の配列から組み立てる。
// 文章側に金額を直書きすると、価格改定時に片方だけ古い金額を表示し続け、
// 特商法上の表示不備になる（#38 のレビュー指摘）。
export const PRICE_LIST_SENTENCE =
  `月額 ${MONTHLY_PRICES_TAX_INCLUDED.map((p) => formatYen(p.price)).join(' / ')}` +
  '（いずれも税込）。ご契約いただくコンテンツ数（中央競馬 / 地方競馬 / 競輪）により決まります。';

export const PRICE_BY_CONTENTS_SENTENCE =
  '有料プランの月額料金は、契約するコンテンツ数に応じて、' +
  MONTHLY_PRICES_TAX_INCLUDED.map((p) => `${p.contents}コンテンツ ${formatYen(p.price)}`).join('、') +
  '（いずれも税込）とします。';

// 規約・ポリシーの改定時はこの日付を更新する（手順は docs/manuals/legal-operations.md）。
export const LEGAL_LAST_UPDATED = '2026年10月4日';

// 有料プランの新規申込みを締め切った日（#262）。利用規約の附則（効力発生日）と特商法表記で使う。
// ⚠️ 効力発生日を過去の日付にしない。本番反映日がこの日付より後になる場合は、反映前に
// LEGAL_LAST_UPDATED と一緒に反映日へ直して build し直す（docs/manuals/deployment.md の #262 の手順）。
// 既存利用者に不利な変更として周知期間が要るかは法務確認待ち（docs/manuals/legal-operations.md §2）。
export const SIGNUP_CLOSED_DATE = '2026年10月4日';

// プライバシーポリシー第6条（Google アナリティクスの利用、#263）の効力発生日。
// GA のタグを本番に出す日（反映日）にする。過去の日付にしない。
export const ANALYTICS_EFFECTIVE_DATE = '2026年10月4日';

// フッターと各ページの相互リンクで使う。表示順もこの配列に従う。
export const LEGAL_LINKS = [
  { label: '特定商取引法に基づく表記', path: '/tokushoho' },
  { label: '利用規約', path: '/terms' },
  { label: 'プライバシーポリシー', path: '/privacy' },
];
